/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.24.0
 * @since 1.23.2
 */

import { IProductResponse } from '../tariffsAndServicesProductTypes';
import { IProductCategoryIds } from '../tariffsAndServicesTypes';

export const getRelatedCategoryIds = (list: IProductResponse): IProductCategoryIds => {
    const tariffsIds: number[] = [];
    const servicesIds: number[] = [];
    const campaignTariffsIds: number[] = [];
    const campaignServicesIds: number[] = [];

    list.tariffs?.forEach((el) => {
        if (el.groups) tariffsIds.push(...el.groups);
    });
    list.services?.forEach((el) => {
        if (el.groups) servicesIds.push(...el.groups);
    });
    list.campaignTariffs?.forEach((el) => {
        if (el.groups) campaignTariffsIds.push(...el.groups);
    });
    list.campaignServices?.forEach((el) => {
        if (el.groups) campaignServicesIds.push(...el.groups);
    });

    return {
        tariffsCartegoryIds: [...new Set(tariffsIds)],
        servicesCategoryIds: [...new Set(servicesIds)],
        campaignTariffsCartegoryIds: [...new Set(campaignTariffsIds)],
        campaignServicesCategoryIds: [...new Set(campaignServicesIds)],
    };
};
